import pluralize from "pluralize";
import {FiTrash} from "react-icons/fi";

import {ButtonWithMutationAndConfirmationDialog} from "@/components/ButtonWithMutationAndConfirmationDialog/ButtonWithMutationAndConfirmationDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {GQL_STATUS_PAGE_QUERY} from "@/lib/queries/statuspages.ts";
import {GQL_EXTERNAL_USERS, GQL_EXTERNAL_USERS_DELETE} from "@/lib/queries/statuspagesExternalUsers.ts";

interface DeleteExternalUserButtonProps {
  statusPageID: number;
  userIds: number[];
  onSuccess?: () => void;
}
export const DeleteExternalUserButton = ({statusPageID, userIds, onSuccess}: DeleteExternalUserButtonProps) => {
  return (
    <ButtonWithMutationAndConfirmationDialog
      dialogType={"delete"}
      dialogTitle={`Delete External ${pluralize("User", userIds.length)}`}
      dialogElement={
        <span>Are you sure you want to delete selected External {pluralize("User", userIds.length)}?</span>
      }
      mutation_GQL={GQL_EXTERNAL_USERS_DELETE}
      mutation_variables={{statusPageID, userIds: userIds}}
      mutation_hook_options={{
        refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_EXTERNAL_USERS],
      }}
      postMutationAction={() => {
        if (onSuccess) {
          onSuccess();
        }
      }}
      variant="tableCrown"
      tooltip={false}
    >
      <Icon icon={FiTrash} /> Delete
    </ButtonWithMutationAndConfirmationDialog>
  );
};
